import type { SocialMediaCarousel } from 'types/capi/modules';

import SocialMediaCard from '~/components/Social/SocialMediaCard';
import {
  TssSocialIcon,
  TswSocialIcon
} from '~/components/Social/SocialMediaIcon';

import Carousel from './Carousel';

type Props = {
  module: SocialMediaCarousel;
};

export default function SocialMediaCarousel({ module }: Props) {
  return (
    <div className="py-10">
      <div className="flex flex-col gap-8 pb-8 md:justify-center">
        <h1 className="text-center text-[32px] font-normal md:text-[40px]">
          Join the community
        </h1>
        <div className="flex flex-row justify-center gap-2 md:gap-6">
          <SocialMediaCard group="tss" icon={<TssSocialIcon />} />
          <SocialMediaCard group="tsw" icon={<TswSocialIcon />} />
        </div>
      </div>
      <Carousel slides={module.items} />
    </div>
  );
}
